import { DittoWordmark, Heading } from '@dittolive/anvil'
import { PropsWithChildren } from 'react'

export function LoginLayout({
  title,
  children,
}: PropsWithChildren<{ title: string }>) {
  return (
    <main className="bg-background text-foreground-normal flex min-h-screen items-center justify-center px-5 py-12">
      <div className="w-full max-w-sm space-y-6">
        <DittoWordmark className="mx-auto mb-10 block" />
        <Heading level={1}>{title}</Heading>
        {children}
      </div>
    </main>
  )
}
